import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonComponent } from 'src/app/shared/components/common-component';
import { AtencionService } from 'src/core/atencion/atencion.service';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Consulta } from 'src/core/consulta/consulta.types';

@Component({
  selector: 'app-citas-programadas',
  templateUrl: './citas-programadas.component.html',
  styleUrls: ['./citas-programadas.component.css'],
})
export class CitasProgramadasComponent
  extends CommonComponent
  implements OnInit
{
  @ViewChild('divCalendar') divCalendar!: ElementRef;
  consultas: Consulta[] = [];
  consultasByDate = null;
  fechas = [];

  constructor(
    private _consultaService: ConsultaService,
    private _atencionService: AtencionService,
    _snackBar: MatSnackBar
  ) {
    super(_snackBar);
  }

  ngOnInit(): void {
    this.getConsultas();
  }

  getConsultas() {
    this._consultaService._consultasUsuarioVet$.subscribe({
      next: (consultas: Consulta[]) => {
        this.consultas = [];
        consultas.forEach((consulta) => {
          if ([2, 3].includes(+consulta.consultaEstadoCita)) {
            consulta.showComponent = true;
            //consulta.consultaNombreAtencion = this._atencionService.getAtencionByIdInList(consulta.consultaIdAtencion).nombre;
            this.consultas.push(consulta);
          }
        });
        this.consultasByDate = this.estructuraConsultasPorFecha(this.consultas);
        this.fechas = Object.keys(this.consultasByDate).sort((a, b) =>
          a.localeCompare(b)
        );
      },
      error: (error: any) => {
        console.log('error : ', error);
        this.openSnackBar(error.toString());
      },
    });
  }

  estructuraConsultasPorFecha(
    consultas: Consulta[]
  ): Record<string, Consulta[]> {
    return consultas.reduce(
      (acc: Record<string, Consulta[]>, consulta: Consulta) => {
        const fecha = new Date(consulta.consultaFechaCita)
          .toISOString()
          .split('T')[0];
        acc[fecha] = [...(acc[fecha] || []), consulta];
        acc[fecha].sort((a, b) =>
          a.consultaHoraCita.localeCompare(b.consultaHoraCita)
        );
        return acc;
      },
      {}
    );
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    //const divElement = this.el.nativeElement.querySelector('.mi-div');
    const divRect = this.divCalendar.nativeElement.getBoundingClientRect();
    const mouseX = event.clientX;
    const mouseY = event.clientY;

    // Verificar si el mouse está dentro de los límites del div
    if (
      mouseX >= divRect.left &&
      mouseX <= divRect.right &&
      mouseY >= divRect.top &&
      mouseY <= divRect.bottom
    ) {

      const distanciaIzquierda = mouseX - divRect.left;
      const distanciaDerecha = divRect.right - mouseX;
      if (distanciaIzquierda <= 100 ) {
        this.divCalendar.nativeElement.scrollLeft -= 40;
      }
      if (distanciaDerecha <= 100) {
        this.divCalendar.nativeElement.scrollLeft += 40;
      }
    }
  }

  searchEvt(event: any){
    var word = event.target.value?.toLowerCase();
    for(let i = 0; i < this.consultas.length; i++){
      if(this.consultas[i].consultaNombreAtencion.toLowerCase().includes(word) || word.length === 0){
        this.consultas[i].showComponent = true;
      }else{
        this.consultas[i].showComponent = false;
      }
    }
    this.consultasByDate = this.estructuraConsultasPorFecha(this.consultas);
    this.fechas = Object.keys(this.consultasByDate).sort((a, b) =>
      a.localeCompare(b)
    );
  }

  orderByDate( orden) {
    if (orden === 'asc') {
      this.fechas = Object.keys(this.consultasByDate).sort((a, b) =>
      a.localeCompare(b)
    );
    } else if(orden === 'desc') {
      this.fechas = Object.keys(this.consultasByDate).sort((a, b) =>
      b.localeCompare(a)
    );
    }
  }
}
